import { createRoute } from '@tanstack/react-router';
import { z } from 'zod/v4';
import { appRoute } from '@/features/dashboard/_root/routes/appRoute.tsx';
import { ShieldCheck, Tag, Users } from 'lucide-react';
import InsurancesPage from '@/features/dashboard/insurances/pages/InsurancesPage.tsx';
import { type ScreenTab } from '@/components/ui/TabScreen.tsx';

export enum InsurancesTab {
  PARTICIPANTS = 'participants',
  CLIENTS = 'clients',
  TYPES = 'types',
}

export const INSURANCES_TABS: readonly ScreenTab<InsurancesTab>[] = [
  {
    value: InsurancesTab.PARTICIPANTS,
    label: 'Ubezpieczeni uczestnicy',
    icon: Users,
    hint: 'kto ma polisę',
  },
  {
    value: InsurancesTab.CLIENTS,
    label: 'Klienci z ubezpieczeniem',
    icon: ShieldCheck,
    hint: 'polisy zapisujących',
  },
  {
    value: InsurancesTab.TYPES,
    label: 'Typy ubezpieczeń',
    icon: Tag,
    hint: 'oferta do wyboru',
  },
];

const searchSchema = z.object({
  // Brak zakładki to menu na wąskim ekranie — patrz `TabScreen`.
  tab: z.enum(InsurancesTab).optional().catch(undefined),
});

export const insurancesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/insurances',
  component: InsurancesPage,
  validateSearch: searchSchema,
});
